import dayjs from 'dayjs';
import { ChangeEventHandler, FC, useCallback, useRef, useState } from 'react';

import './mm-yy.scss';

var customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

const DayInput: FC<{
  date?: Date | number | string | null;
  label?: string;
  setDate: (date?: number) => void;
  disabled?: boolean;
  required?: boolean;
}> = ({ date, label, setDate, disabled, required }) => {
  const [input, setInput] = useState(!date ? '' : dayjs(date).format('MM/DD/YY'));

  const labelRef = useRef<HTMLLabelElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleReset = useCallback(() => {
    setInput('');
    inputRef.current?.setCustomValidity('');
    setDate(undefined);
  }, [setDate, setInput]);

  const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    e => {
      if (!e.target.value) {
        return handleReset();
      }

      // Format as MM/DD/YY
      let formatValue = e.target.value
        .replace(/[^0-9]/g, '') // Remove non-numeric
        .slice(0, 6); // Only allow 6 digits (MMDDYY)
      if (formatValue.length >= 2) {
        formatValue = formatValue.slice(0, 2) + '/' + formatValue.slice(2);
      }
      if (formatValue.length >= 5) {
        formatValue = formatValue.slice(0, 5) + '/' + formatValue.slice(5);
      }

      setInput(formatValue);
      const dayjsValue = dayjs(formatValue, 'MM/DD/YY', true);

      if (dayjsValue.isValid()) {
        e.target.setCustomValidity('');
        setDate(dayjsValue.valueOf());
      } else {
        e.target.setCustomValidity('Invalid date (expected MM/DD/YY)');
      }
    },
    [handleReset, setDate, setInput]
  );

  return (
    <div id="mm-yy" className="w-100">
      <input
        type="text"
        inputMode="numeric"
        placeholder="MM/DD/YY"
        className={'w-100'}
        id={label}
        value={input}
        onChange={handleChange}
        ref={inputRef}
        disabled={disabled}
        required={required}
      />
      {!!label && (
        <label htmlFor={label} ref={labelRef}>
          {label}
          {required && ' *'}
        </label>
      )}
      <button className="btn-back clear-btn" type="button" onClick={handleReset} tabIndex={-1}>
        <span className="material-icons icon-large">close</span>
      </button>
    </div>
  );
};

export default DayInput;
